import React from "react";
import SettingNav from "../components/setting/SettingNav";

export default function Settings() {
  return (
    <div className="wrapper wrapper-content">
      <SettingNav />
    </div>
  );
}
